// extracted by mini-css-extract-plugin
module.exports = {"content":"downloads_content__U3E8S"};